import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Home from "./pages/Home";
import PostDetails from "./pages/PostDetails";
function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/details/:postID" element={<PostDetails />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
